import { Button, Stack, Typography } from '@mui/material';

import ContinueAndPreviewContainer from 'components/v2/container/ContinueAndPreviewContainer';
import { ArrowRightIcon } from 'components/v2/icons/ArrowRightIcon';
import { LAYOUT_SPACING } from 'constants/ui/style';
import NewPreviewReceipt from '../receipt/NewPreviewReceipt';
import CollapsibleSection from 'components/v2/accordion/CollapsibleSection';
import DataGridTable from 'components/v2/table/DataGridTable';
import { useCreateNewOrderStep4 } from 'hooks/services/useCreateNewOrderStep4';
import SkeletonContainer from 'components/v2/container/SkeletonContainer';
import Show from 'components/v2/show/Show';

const CreateOrderStep4 = () => {
  const { t, ui, groupedSingleProducts, apiState, totalPrice, isDisableCreateOrder, handleCreateNewOrder } =
    useCreateNewOrderStep4();

  return (
    <Stack direction="row" justifyContent="space-between" sx={{ height: '100%' }}>
      <Stack
        spacing={LAYOUT_SPACING.CARD.md}
        sx={{ width: '100%', padding: '1rem 1rem 1rem 0', overflowY: 'auto' }}
        mb={{ xs: 10, md: 0 }}
      >
        <SkeletonContainer
          columns={{ xs: 1 }}
          rows={{ xs: 3 }}
          loading={apiState.loadingSaleProducts}
          skeletonHeight={250}
        >
          <Show
            when={Object.keys(groupedSingleProducts).length > 0}
            fallback={
              <Stack justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
                {t('common.terms.noData')}
              </Stack>
            }
          >
            {Object.values(groupedSingleProducts).map((group, index) => (
              <CollapsibleSection key={group.categoryId} title={group.displayCategory} defaultOpen={index === 0}>
                <DataGridTable
                  rows={group.rows}
                  columns={ui.table.columns.buildColumns(group.categoryId)}
                  isHideFooter
                  loading={apiState.loadingSaleProducts}
                  sx={{ minHeight: 200 }}
                />
              </CollapsibleSection>
            ))}
          </Show>
        </SkeletonContainer>
      </Stack>

      <ContinueAndPreviewContainer
        continueElement={
          <Stack gap={2}>
            {apiState?.showPrice && (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ display: { xs: 'none', sm: 'flex' } }}
              >
                <Typography variant="h5">{t('common.terms.totalPrice')}</Typography>
                <Typography variant="h5" fontWeight={600}>
                  {totalPrice}
                </Typography>
              </Stack>
            )}

            <Button
              size="large"
              variant="contained"
              fullWidth
              endIcon={<ArrowRightIcon />}
              onClick={handleCreateNewOrder}
              disabled={isDisableCreateOrder}
              loading={apiState.isCreatingOrder}
              sx={{ minWidth: 'fit-content' }}
            >
              {t('orders.pages.new.stepThree.confirmAndOrder')}
            </Button>
          </Stack>
        }
        previewElement={<NewPreviewReceipt />}
      />
    </Stack>
  );
};

export default CreateOrderStep4;
